/*
 * Copyright (C) Motorola Solutions, INC.
 * All Rights Reserved.
 */

import { UserAuthenticationRecord } from 'CalltakingCoreApi';

export class UserFunctions {

    public static formatName(user: UserAuthenticationRecord): string {
        return user.lastName && user.firstName ? `${user.lastName}, ${user.firstName}` : user.lastName ? user.lastName : user.username;
    }
}
